export const HEADER_TEST_ID                    = 'header-test';
export const INDEX_TEST_ID                     = 'activation-index-test';
export const ACCOUNT_SIDEBAR_TEST_ID           = 'account-sidebar-test';
export const ACCOUNT_SIDEBAR_MENU_LINK_TEST_ID = 'account-sidebar-menu-link-test';
export const SIGN_UP_FORM_TEST_IDS             = 'sign-up-test';
export const SIGN_IN_FORM_TEST_ID              = 'login-form-test';
export const SIGN_IN_GENERIC_ERROR_TEST_ID     = 'login-generic-error-test';
export const SIGN_UP_PHONE_FORM_TEST_ID        = '2fa-form-test';
export const SIGN_UP_PHONE_VERIFY_FORM_TEST_ID = '2fa-verify-form-test';
export const SIGN_UP_PHONE_ERROR_TEST_ID       = '2fa-error-message-test';

export const FIRST_NAME_TEST_ID         = 'first-name-test';
export const LAST_NAME_TEST_ID          = 'last-name-test';
export const EMAIL_TEST_ID              = 'email-test';
export const TERMS_CHECKBOX_TEST_ID     = 'terms-checkbox-test';

export const BASIC_PROFILE_TEST_ID              = 'basic-profile-test';
export const BASIC_PROFILE_PROGRESS_TEST_ID     = 'basic-profile-progress-test';
export const BASIC_PROFILE_CONFIRMATION_TEST_ID = 'basic-profile-confirmation-test';

export const HELP_TERMS_TEST_ID        = 'terms-test';
export const HELP_PRIVACY_TEST_ID      = 'privacy-test';
export const HELP_INVITE_TERMS_TEST_ID = 'invite-terms-test';
export const HELP_LEADERBOARD_TEST_ID  = 'leaderboard-test';

export const CONTACT_US_TEST_IDS = {
  INDEX: 'cu-index-test',
  FORM : 'cu-form-test'
};

export const SUBJECT_TEST_ID     = 'subject-test';
export const DESCRIPTION_TEST_ID = 'description-test';

export const PERMISSIONS_TEST_ID = 'permissions-test';
export const TOGGLE_TEST_ID      = 'toggle-test';

export const FORGOT_PASSWORD_TEST_IDS = {
  EMAIL_SUBMIT: 'email-submit',
  SUCCESS     : 'email-success',
  ERROR       : 'email-error',
  HEADER      : 'email-header',
  MAIN_PAGE   : 'email-main'
};

export const EXPIRED_PASSWORD_BANNER_TEST_ID = 'expired-password-banner-test';

export const LOGO_TEST_ID = 'logo-test';
